/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */


import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const msalConfig: Configuration = {
    auth: {
        clientId: environment.sso.adClientId,
        authority: 'https://login.microsoftonline.com/'+environment.sso.adTenantId,
        redirectUri: '/user',
        postLogoutRedirectUri:'/login',
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
            },
            logLevel: LogLevel.Verbose
        }
    }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = new Map(
[
    // ["http://192.168.1.81:9045/",["0099b070-609e-426c-a09d-4ded0b3fffe5/api-access"]],
    ["https://app-dfds-astro-webapi-dev-weu-001.azurewebsites.net/",["0099b070-609e-426c-a09d-4ded0b3fffe5/api-access"]],
    ["https://app-dfds-astro-webapi-tst-weu-002.azurewebsites.net/",["0099b070-609e-426c-a09d-4ded0b3fffe5/api-access"]],
    ["https://app-dfds-astro-webapi-uat-weu-002.azurewebsites.net/",["0099b070-609e-426c-a09d-4ded0b3fffe5/api-access"]],
    ["https://app-dfds-astro-webapi-prd-weu-001.azurewebsites.net/",["0099b070-609e-426c-a09d-4ded0b3fffe5/api-access"]],
    ["https://graph.microsoft.com/v1.0/me",["https://graph.microsoft.com/User.Read"]]
]);

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: environment.msalLogInRequest
};
